const Config = {
  env: import.meta.env.VITE_APP_ENV,
  isDev: import.meta.env.VITE_APP_ENV === 'development',
  isProduction: import.meta.env.VITE_APP_ENV === 'production',
  releaseVersion: import.meta.env.VITE_RELEASE_VERSION || 'unknown',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  payBaseUrl: import.meta.env.VITE_PAY_BASE_URL,
  kycApiBaseUrl: import.meta.env.VITE_APP_KYC_API_BASE_URL,
  appHostUrl: import.meta.env.VITE_HOST,
  idvAppHostUrl: import.meta.env.VITE_IDV_FE_HOST,
  checkoutGatewayPublicKeyForSAU: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_SAU,
  checkoutGatewayPublicKeyForARE: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_ARE,
  checkoutGatewayPublicKeyForKWD: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_KWD,
  checkoutGatewayPublicKeyForQAR: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_QAR,
  checkoutGatewayPublicKeyForBHD: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_BHD,
  checkoutGatewayPublicKeyForOMN: import.meta.env.VITE_CHECKOUT_GATEWAY_PK_OMN,
  checkoutGatewayPublicKeyForSAUV2: import.meta.env
    .VITE_CHECKOUT_GATEWAY_PK_SAU_V2,
  checkoutGatewayPublicKeyForAREV2: import.meta.env
    .VITE_CHECKOUT_GATEWAY_PK_ARE_V2,
  checkoutGatewayPublicKeyForKWDV2: import.meta.env
    .VITE_CHECKOUT_GATEWAY_PK_KWD_V2,
  checkoutGatewayPublicKeyForQARV2: import.meta.env
    .VITE_CHECKOUT_GATEWAY_PK_QAR_V2,
  checkoutGatewayPublicKeyForBHDV2: import.meta.env
    .VITE_CHECKOUT_GATEWAY_PK_BHD_V2,
  checkoutGatewayPublicKeyForOMNV2: import.meta.env
    .VITE_CHECKOUT_GATEWAY_PK_OMN_V2,
  applepayVersion: 5,
  gtmId: import.meta.env.VITE_GTM_ID,
  paymentPlanInstallmentExcludeMerchantIds:
    import.meta.env.VITE_PAYMENT_PLAN_INSTALLMENT_EXCLUDE_MERCHANT_IDS?.split(
      ','
    ),
  verificationAmount: 1,
  sardineKey: import.meta.env.VITE_SARDINE_KEY,
  statsigKey: import.meta.env.VITE_STATSIG_CLIENT_KEY,
  tamaraMerchantPk: import.meta.env.VITE_TAMARA_MECHANT_PK,
  RUDDERSTACK_WRITE_KEY: import.meta.env.VITE_RUDDERSTACK_WRITE_KEY,
  RUDDERSTACK_DATA_PLANE_URL: import.meta.env.VITE_RUDDERSTACK_DATA_PLANE_URL,
}

export default Config
